const SoldIconSvg = ({
  height = 22,
  width = 22,
  viewBox = '2 2 20 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M21.4 14.25L14.25 21.4C14.05 21.6 13.825 21.75 13.575 21.85C13.325 21.95 13.075 22 12.825 22C12.575 22 12.325 21.95 12.075 21.85C11.825 21.75 11.6 21.6 11.4 21.4L2.575 12.575C2.39167 12.3917 2.25 12.1793 2.15 11.938C2.05 11.6967 2 11.4423 2 11.175V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H11.175C11.4417 2 11.7 2.05433 11.95 2.163C12.2 2.27167 12.4167 2.41733 12.6 2.6L21.4 11.425C21.6 11.625 21.746 11.85 21.838 12.1C21.93 12.35 21.9757 12.6 21.975 12.85C21.9743 13.1 21.9287 13.346 21.838 13.588C21.7473 13.83 21.6013 14.0507 21.4 14.25ZM12.825 20L19.975 12.85L11.15 4H4V11.15L12.825 20ZM6.5 8C6.91667 8 7.271 7.85433 7.563 7.563C7.855 7.27167 8.00067 6.91733 8 6.5C7.99933 6.08267 7.85367 5.72867 7.563 5.438C7.27233 5.14733 6.918 5.00133 6.5 5C6.082 4.99867 5.728 5.14467 5.438 5.438C5.148 5.73133 5.002 6.08533 5 6.5C4.998 6.91467 5.144 7.269 5.438 7.563C5.732 7.857 6.086 8.00267 6.5 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default SoldIconSvg;
